import React, { createContext, useState } from "react";

export const SelectedBudgetContext = createContext(); 

export const SelectedBudgetProvider = ({ children }) => {
    const [selectedBudget, setSelectedBudget] = useState('None');

  return (
    <SelectedBudgetContext.Provider value={{ selectedBudget, setSelectedBudget }}>
      {children} 
    </SelectedBudgetContext.Provider>
  );
};
